import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47cda8ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details-container row" }
const _hoisted_2 = { class: "col-12 col-md-6 col-xl-5 mb-5 mb-md-0 d-flex justify-content-center justify-content-md-end align-items-center title-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Project Details")
], -1))
const _hoisted_4 = { class: "col-12 col-md-6 col-xl-7 row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageContainer = _resolveComponent("ImageContainer")!
  const _component_ContentField = _resolveComponent("ContentField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_ImageContainer, {
        class: "image",
        imageUrl: _ctx.image
      }, null, 8, ["imageUrl"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ContentField, {
        class: "col-6 col-xl-4",
        title: "Developer",
        content: _ctx.getDeveloper()
      }, null, 8, ["content"]),
      _createVNode(_component_ContentField, {
        class: "col-6 col-xl-4",
        title: "Tenure",
        content: _ctx.getTenure()
      }, null, 8, ["content"]),
      _createVNode(_component_ContentField, {
        class: "col-6 col-xl-4",
        title: "Status",
        content: _ctx.getStatus()
      }, null, 8, ["content"]),
      _createVNode(_component_ContentField, {
        class: "col-6 col-xl-4",
        title: "Expected Completion",
        content: _ctx.getExpectedCompletion()
      }, null, 8, ["content"]),
      _createVNode(_component_ContentField, {
        class: "col-6 col-xl-4",
        title: "Title",
        content: _ctx.getTitle()
      }, null, 8, ["content"]),
      _createVNode(_component_ContentField, {
        class: "col-6 col-xl-4",
        title: "Category",
        content: _ctx.getCategory()
      }, null, 8, ["content"]),
      _createVNode(_component_ContentField, {
        class: "col-6 col-xl-4",
        title: "Unit Sizes",
        content: _ctx.getUnitSizes()
      }, null, 8, ["content"]),
      _createVNode(_component_ContentField, {
        class: "col-6 col-xl-4",
        title: "Unit Prices",
        content: _ctx.getUnitPrice(),
        subcontent: "(Before Discount)"
      }, null, 8, ["content"]),
      _createVNode(_component_ContentField, {
        class: "col-6 col-xl-4",
        title: "Furnished",
        content: _ctx.getFurnished()
      }, null, 8, ["content"])
    ])
  ]))
}